import type { ReactElement, SVGProps } from 'react';

export default function PillIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.3828 3.71645C12.012 2.08737 14.654 2.08734 16.2832 3.71645C17.9124 5.34565 17.9123 7.98759 16.2832 9.61684L9.61621 16.2838C8.83453 17.0674 7.77281 17.5075 6.66602 17.5075C5.55923 17.5074 4.49746 17.0674 3.71582 16.2838C2.93222 15.5022 2.49222 14.4405 2.49219 13.3336C2.49219 12.2268 2.93227 11.1651 3.71582 10.3834L10.3828 3.71645ZM4.7793 11.6872C4.1986 12.307 3.9696 13.1838 4.18164 14.0143C4.40785 14.9001 5.09958 15.5918 5.98535 15.818C6.87103 16.0442 7.80938 15.7689 8.43262 15.1002L11.7666 11.7672L8.2334 8.23305L4.7793 11.6872Z"
        fill="currentColor"
      />
    </svg>
  );
}
